module.exports = __webpack_public_path__ + "img/indocyber-logo.7bde7edc.png";